import React from 'react';
import { useTranslation } from '../components/TranslationContext';
import { Helmet } from 'react-helmet';
import '../styles/contact.css';
import '../styles/root.css';
import prisedecontact from '../assets/usine/Marine & Moi-85.jpg';
import consultation from '../assets/usine/Marine & Moi-84.jpg';
import projectpropal from '../assets/usine/Marine & Moi-95.jpg';
import validation from '../assets/usine/projet.jpg';
import sample from '../assets/usine/Marine & Moi-17.jpg';
import assemblage from '../assets/usine/Marine & Moi-34.jpg';
import quality from '../assets/usine/Marine & Moi-56.jpg';
import delivery from '../assets/usine/Marine & Moi-165.jpg';
import support from '../assets/usine/support.jpg';

const Contact = () => {
  const { translate } = useTranslation();
  const contact = translate('contact');

  return (
    <>
      <Helmet>
        <title>Marine & Moi - Contact</title>
        <meta name="description" content="Contactez Marine & Moi pour discuter de vos besoins en textiles premium." />
        <meta name="keywords" content="contact, textiles, premium, besoins" />
      </Helmet>
      <h1 className="contact-title">{contact.contactTitle}</h1>
      <section className="process-section">
        <div className="process-container">
          <div className="process-section">
            <div className="process-image">
              <img src={prisedecontact} alt={contact.process1} />
            </div>
            <div className="process-content">
              <div className="process-number">01</div>
              <h2 className="process-title">{contact.process1}</h2>
              <p className="process-description">{contact.process1Description}</p>
            </div>
          </div>
          <div className="process-section">
            <div className="process-image">
              <img src={consultation} alt={contact.process2} />
            </div>
            <div className="process-content">
              <div className="process-number">02</div>
              <h2 className="process-title">{contact.process2}</h2>
              <p className="process-description">{contact.process2Description}</p>
            </div>
          </div>
          <div className="process-section">
            <div className="process-image">
              <img src={projectpropal} alt={contact.process3} />
            </div>
            <div className="process-content">
              <div className="process-number">03</div>
              <h2 className="process-title">{contact.process3}</h2>
              <p className="process-description">{contact.process3Description}</p>
            </div>
          </div>
          <div className="process-section">
            <div className="process-image">
              <img src={validation} alt={contact.process4} />
            </div>
            <div className="process-content">
              <div className="process-number">04</div>
              <h2 className="process-title">{contact.process4}</h2>
              <p className="process-description">{contact.process4Description}</p>
            </div>
          </div>
          <div className="process-section">
            <div className="process-image">
              <img src={sample} alt={contact.process5} />
            </div>
            <div className="process-content">
              <div className="process-number">05</div>
              <h2 className="process-title">{contact.process5}</h2>
              <p className="process-description">{contact.process5Description}</p>
            </div>
          </div>
          <div className="process-section">
            <div className="process-image">
              <img src={assemblage} alt={contact.process6} />
            </div>
            <div className="process-content">
              <div className="process-number">06</div>
              <h2 className="process-title">{contact.process6}</h2>
              <p className="process-description">{contact.process6Description}</p>
            </div>
          </div>
          <div className="process-section">
            <div className="process-image">
              <img src={quality} alt={contact.process7} />
            </div>
            <div className="process-content">
              <div className="process-number">07</div>
              <h2 className="process-title">{contact.process7}</h2>
              <p className="process-description">{contact.process7Description}</p>
            </div>
          </div>
          <div className="process-section">
            <div className="process-image">
              <img src={delivery} alt={contact.process8} />
            </div>
            <div className="process-content">
              <div className="process-number">08</div>
              <h2 className="process-title">{contact.process8}</h2>
              <p className="process-description">{contact.process8Description}</p>
            </div>
          </div>
          <div className="process-section">
            <div className="process-image">
              <img src={support} alt={contact.process9} />
            </div>
            <div className="process-content">
              <div className="process-number">09</div>
              <h2 className="process-title">{contact.process9}</h2>
              <p className="process-description">{contact.process9Description}</p>
            </div>
          </div>
        </div>
      </section>
      <form action="scripts/form.php" method="post">
        <div className="form-group">
          <label htmlFor="name">{contact.name}</label>
          <input type="text" id="name" name="name" required />
        </div>
        <div className="form-group">
          <label htmlFor="firstname">{contact.firstname}</label>
          <input type="text" id="firstname" name="firstname" required />
        </div>
        <div className="form-group">
          <label htmlFor="company">{contact.company}</label>
          <input type="text" id="company" name="company" />
        </div>
        <div className="form-group">
          <label htmlFor="email">{contact.email}</label>
          <input type="email" id="email" name="email" required />
        </div>
        <div className="form-group">
          <label htmlFor="phone">{contact.phone}</label>
          <div>
            <select id="phone-prefix" name="phone-prefix">
              <option value="+261">+261</option>
              <option value="+33">+33</option>
              <option value="+1">+1</option>
            </select>
            <input type="tel" id="phone" name="phone" required />
          </div>
        </div>
        <div className="buttons">
          <button type="submit">{contact.submit}</button>
        </div>
      </form>
      <div className="contact-buttons">
        <a href="tel:+33751272623"><button type="button">{contact.callUs}</button></a>
        <a href="mailto:minaze.mg@gmail.com"><button type="button">{contact.writeUs}</button></a>
      </div>
    </>
  );
};

export default Contact;
